import React from "react";
import ValueCard from "../../components/Cards/ValueCard";
import { routes } from "../../config/pillveryVariables";

export default function DashboardCardValues({ statistics, loading }) {
  {
    /*icon-card-primary*/
  }
  {
    /*icon-card-success*/
  }
  {
    /*icon-card-info*/
  }
  {
    /*icon-card-dark*/
  }
  var dateFormat = require("dateformat");
  const now = new Date();
  let date;
  if (now.getMonth() == 11) {
    date = new Date(now.getFullYear() + 1, 0, 1);
  } else {
    date = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  }

  return (
    <>
      <ValueCard
        label="Total Pending Orders"
        value={statistics?.pending_orders || 0}
        loading={loading}
        detailsPath={routes.PENDING_ORDERS}
        bgColorClass="icon-card-danger"
        cardWidth={3}
        loaderBorderColor="#FFFFFF"
      />
      <ValueCard
        label="Total Active Orders"
        value={statistics?.active_orders || 0}
        loading={loading}
        detailsPath={routes.ACTIVE_ORDERS}
        bgColorClass="icon-card-primary"
        cardWidth={3}
        loaderBorderColor="#FFFFFF"
      />
      {/*<ValueCard*/}
      {/*    label           = "Total Completed Orders"*/}
      {/*    value           = {59467}*/}
      {/*    detailsPath     = "#"*/}
      {/*    bgColorClass    = "icon-card-warning"*/}
      {/*    cardWidth       = { 3 }*/}
      {/*/>*/}
      <ValueCard
        label="Total Number of Orders"
        value={statistics?.total_orders || 0}
        loading={loading}
        detailsPath={routes.HISTORY_ORDERS}
        bgColorClass="pillvery-icon-card-primary"
        cardWidth={3}
        loaderBorderColor="#FFFFFF"
      />
      {/*<ValueCard*/}
      {/*    label           = "Account Balance"*/}
      {/*    value           = {"JOD120,000.00"}*/}
      {/*    detailsPath     = "#"*/}
      {/*    bgColorClass    = "icon-card-info"*/}
      {/*    cardWidth       = { 6 }*/}
      {/*/>*/}
      <ValueCard
        label="Amount To Be Settled In The Next Cycle (JOD)"
        value={
          parseFloat(
            statistics?.accountingStatistics?.total_balance
          )?.toFixed(3) == "NaN"
            ? 0
            : parseFloat(
                statistics?.accountingStatistics?.total_balance
              )?.toFixed(3)
        }
        loading={loading}
        detailsPath="#"
        hasDetailsBtn={false}
        bgColorClass="icon-card-dark"
        description="Next Settlement Date"
        date={dateFormat(date, "dd mmm yyyy")}
        cardWidth={3}
        loaderBorderColor="#FFFFFF"
      />
    </>
  );
}
